module.exports = __webpack_public_path__ + "img/Monte_Kope_116.e323a6d6.jpg";